import actions from '../actions';

export const initState = {
  selected_product: null,
  products: [],
  total_count: 0,
  page: 1,
  loading: false
};

export default function productReducer(state = initState, action) {
  switch (action.type) {
    case actions.product.INIT:
      return { ...initState };
    case actions.product.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
